let lastId = 0;

export default function getUid() {
    lastId++;
    return `${lastId}`;
}